<template>
  <div class="connectionsList" v-if="requests && requests.length">
    <div class="top">
      <h1 class="title">{{titleString}}</h1>
    </div>
    <div class="connections">
      <div v-for="(connectRequest, index) in requests" :key="index">
        <Connection 
          :connection="connectRequest"
          :statusType="sentRequests ? 'sent' : 'received'"
        />
        <div v-if="sentRequests">
          <button @click="cancelRequest(index)">
            {{ cancelingRequest ? "Canceling..." : "Cancel request" }}
          </button>
        </div>
        <div v-else>
          <button @click="acceptConnectRequest(index)" class="acceptButton">
            {{ acceptingRequest ? "Accepting..." : "Accept request" }}
          </button>
          <button @click="rejectConnectRequest(index)" class="rejectButton">
            {{ rejectingRequest ? "Rejecting..." : "Reject" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="connectionsList" v-else>
    <div class="top">
      <h1 class="title"> {{noRequestsString}}</h1>
    </div>
  </div>
</template>

<script>
import Connection from "./Connection";

import profileAPIService from "../../../api/profileAPIService";

export default {
  name: "ConnectRequestsList",
  props: {
    requests: Array,
    sentRequests: Boolean,
    userID: String,
  },
  components: {
    Connection,
  },
  data() {
    return {
      acceptingRequest: false,
      rejectingRequest: false,
      cancelingRequest: false
    };
  },
  computed: {
    titleString() {
      return this.sentRequests 
        ? "Sent connection requests" 
        : "Received connection requests";
    },
    noRequestsString() {
      return this.sentRequests
        ? "You have no sent requests :("
        : "You have not received new requests :(";
    }
  },
  methods: {
    // repetitive but blah
    async acceptConnectRequest(index) {
      console.log("index: ", index, this.requests[index]);
      this.acceptingRequest = true;
      const result = await profileAPIService.acceptConnectRequest(
        this.requests[index].CID, 
        this.userID, 
        this.requests[index].UID
      );
      if (result !== null) {
        console.log("@accept results: ", result);
        if (result.status !== "pending") {
          this.requests.splice(index, 1);
        }
      } 
      // TODO handle failure 
      this.acceptingRequest = false;
    },
    async rejectConnectRequest(index) {
      console.log("index: ", index, this.requests[index]);
      this.rejectingRequest = true;
      const result = await profileAPIService.rejectConnectRequest(
        this.requests[index].CID,
        this.userID,
        this.requests[index].UID
      );
      if (result !== null) {
        console.log("@reject results: ", result);
        if (result.status !== "pending") {
          this.requests.splice(index, 1);
        }
      } 
      this.rejectingRequest = false;
    },
    async cancelRequest(index) {
      console.log("INDEX: ", index, this.requests[index]);
      this.cancelingRequest = true;
      const result = await profileAPIService.cancelConnectRequest(
        this.requests[index].CID,
        this.userID,
        this.requests[index].UID
      );
      if (result !== null) {
        console.log("@cancel result:", result);
        if (result.status !== "pending") {
          this.requests.splice(index, 1);
        }
      }
      this.cancelingRequest = false;
    },
    updateConnectionStatus(data, index) {
      console.log("DATA: ", data, index);
    }
  },
  created() {
    console.log("NICE AT LIST");
  }
};
</script>